import { api } from '@creditsights/api-ui-web';
import { Analyst, AnalystsFetchParams } from '../../models';

const moduleV1Uri = 'common/v1/analysts';

const CREDIT_SIGHTS_STAFF_ANALYST_ID = 'analyst/creditsights_staff';

export const fetchAnalyst = async (analystId: string): Promise<Analyst> => {
  if (analystId === CREDIT_SIGHTS_STAFF_ANALYST_ID) {
    return {
      initials: 'cr',
      displayName: 'CreditSights Staff',
      isActiveAuthor: true,
      displayOnTeamsPage: false,
      hasBio: false,
    };
  }
  const { data } = await api.get(`${moduleV1Uri}/${analystId.split('/')[1]}`);
  return data;
};

export const fetchAnalysts = async (analystsParams: AnalystsFetchParams): Promise<Analyst> => {
  const { data: analysts } = await api.get(moduleV1Uri, { params: analystsParams });
  return analysts;
};
